import { Station, Train } from '../types';

export const getFavouriteStations = (): Station[] => {
  const favourites = localStorage.getItem('favouriteStations');
  return favourites ? JSON.parse(favourites) : [];
};

export const setFavouriteStations = (stations: Station[]) => {
  localStorage.setItem('favouriteStations', JSON.stringify(stations));
};

export const DEFAULT_TIME_SAVED_THRESHOLD = 5;

export const getTimeSavedThreshold = (): number => {
  const value = localStorage.getItem('timeSavedThreshold');
  if (value === null) return DEFAULT_TIME_SAVED_THRESHOLD;
  const parsed = parseInt(value, 10);
  return isNaN(parsed) || parsed < 0 ? DEFAULT_TIME_SAVED_THRESHOLD : parsed;
};

export const setTimeSavedThreshold = (threshold: number): void => {
  localStorage.setItem('timeSavedThreshold', Math.max(0, Math.floor(threshold)).toString());
};

const normalizeStationName = (name: string): string =>
  name.trim().toLowerCase().replace(/['’]/g, '');

export const getStationCrs = (
  stationName: string | null | undefined,
  train?: Train
): string => {
  if (!stationName) return '';
  const trimmed = stationName.trim();
  const normalized = normalizeStationName(trimmed);

  if (train) {
    if (train.from_station && normalizeStationName(train.from_station) === normalized && train.from_crs) {
      return train.from_crs;
    }
    if (train.user_destination_station && normalizeStationName(train.user_destination_station) === normalized && train.to_crs) {
      return train.to_crs;
    }
  }

  // Check favourite stations
  try {
    const favourites = localStorage.getItem('favouriteStations');
    if (favourites) {
      const parsed: Station[] = JSON.parse(favourites);
      const match = parsed.find((s) => s.stationName && normalizeStationName(s.stationName) === normalized);
      if (match?.crsCode) return match.crsCode;
    }
  } catch {}

  // Check cached all stations
  try {
    const cached = localStorage.getItem('cachedStations');
    if (cached) {
      const parsed: Station[] = JSON.parse(cached);
      const match = parsed.find((s) => s.stationName && normalizeStationName(s.stationName) === normalized);
      if (match?.crsCode) return match.crsCode;
    }
  } catch {}

  return trimmed;
};
